// extracted by mini-css-extract-plugin
module.exports = {"card":"ProjectCard_card__R1LIa","imageBox":"ProjectCard_imageBox__1ZMUw","image":"ProjectCard_image__2wesi","caption":"ProjectCard_caption__3lGX2"};